import Swal from 'sweetalert2'

const toastConfig = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  // customClass: 'swal-margin-top',
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
export const Toast = (error, message, question = false) => {
  if (question !== true) {
    toastConfig.fire({
      icon: error ? 'error' : 'success',
      title: message
    })
  } else {
    toastConfig.fire({
      icon: 'warning',
      title: message
    })
  }
}

const notificationToastConfig = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
export const NotificationToast = (error, message, question = false) => {
  if (question !== true) {
    notificationToastConfig.fire({
      icon: error ? 'error' : 'success',
      title: message
    })
  } else {
    notificationToastConfig.fire({
      icon: 'warning',
      title: message
    })
  }
}

const baseToastConfig = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
export const BaseToast = (icon, message, text) => {
  return baseToastConfig.fire({
    icon: icon,
    title: message,
    text: text
  })
}

export const ModalToast = async (icon, title, text) => {
  await Swal.fire({ icon, title, text })
}

export default Toast
